import React, { useState } from "react";

import styles from "./slider.module.css";

export type SliderProps = {
  children: React.ReactNode;
};

const Slider = ({ children }: SliderProps) => {
  const [maskEnd, setMaskEnd] = useState(false);
  const [maskStart, setMaskStart] = useState(true);

  const updateMaskState = (el: HTMLElement) => {
    const max = el.scrollWidth - el.clientWidth;
    const EPS = 1;

    const overflowing = max > EPS;
    const atEnd = overflowing && Math.ceil(el.scrollLeft) >= max - EPS;
    const atStart = !overflowing || Math.floor(el.scrollLeft) <= EPS;

    setMaskEnd(atEnd);
    setMaskStart(atStart);
  };

  return (
    <div
      className={`${styles.carouselWrapper} ${maskEnd ? styles.maskEnd : ""} ${
        maskStart ? styles.maskStart : ""
      }`}
    >
      <div
        className={styles.carousel}
        onScroll={(e) => updateMaskState(e.currentTarget)}
      >
        {children}
      </div>
    </div>
  );
};

export { Slider };
